module.exports = "/_next/static/images/icon-linkedin-0c8845d8aa1da201dd7b10317ce28dea.svg";